/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svtag_PolyInputs */

const en_svtag_poly = /** @type {(inputs: Svtag_PolyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#POLY`)
};

const ar_svtag_poly = /** @type {(inputs: Svtag_PolyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#متعدد`)
};

const bn_svtag_poly = /** @type {(inputs: Svtag_PolyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#POLY`)
};

const de_svtag_poly = /** @type {(inputs: Svtag_PolyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#POLY`)
};

const es_svtag_poly = /** @type {(inputs: Svtag_PolyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#POLY`)
};

const fr_svtag_poly = /** @type {(inputs: Svtag_PolyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#POLY`)
};

const pt_svtag_poly = /** @type {(inputs: Svtag_PolyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#POLY`)
};

const zh_svtag_poly = /** @type {(inputs: Svtag_PolyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#POLY`)
};

const tr_svtag_poly = /** @type {(inputs: Svtag_PolyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#POLY`)
};

const ru_svtag_poly = /** @type {(inputs: Svtag_PolyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#POLY`)
};

const pl_svtag_poly = /** @type {(inputs: Svtag_PolyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#POLY`)
};

/**
* | output |
* | --- |
* | "#POLY" |
*
* @param {Svtag_PolyInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svtag_poly = /** @type {((inputs?: Svtag_PolyInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svtag_PolyInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svtag_poly(inputs)
	if (locale === "bn") return bn_svtag_poly(inputs)
	if (locale === "de") return de_svtag_poly(inputs)
	if (locale === "es") return es_svtag_poly(inputs)
	if (locale === "fr") return fr_svtag_poly(inputs)
	if (locale === "pt") return pt_svtag_poly(inputs)
	if (locale === "zh") return zh_svtag_poly(inputs)
	if (locale === "tr") return tr_svtag_poly(inputs)
	if (locale === "ru") return ru_svtag_poly(inputs)
	if (locale === "pl") return pl_svtag_poly(inputs)
	return en_svtag_poly(inputs)
});